module.exports = __webpack_public_path__ + "static/media/PHL.be8930aa.png";